var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dense":"","dark":"","absolute":"","flat":"","inset":""}},[_c('v-toolbar-title',{staticClass:"text-list"},[_vm._v("ระบบจัดการเอกสารโครงการ")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }